exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-9e538d8e],select[data-v-9e538d8e]{border-style:solid}", ""]);

// exports
